import { render, staticRenderFns } from "./SettingsPushNotificationsTableItem.vue?vue&type=template&id=6152fcfa&scoped=true&"
import script from "./SettingsPushNotificationsTableItem.vue?vue&type=script&lang=js&"
export * from "./SettingsPushNotificationsTableItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPushNotificationsTableItem.vue?vue&type=style&index=0&id=6152fcfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152fcfa",
  null
  
)

export default component.exports